export default {
    key: 'pintenfritz',
    type: 'Activity',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    activityId: 'c6bd2ed4-32d9-4bdd-8d1f-8b09222853b0',
    categoryId: undefined,
    defaultDuration: 1440,
    isMultiDay: false,
    isUsingReductionCards: true,
    isUsingKeyCards: false,
    isUsingPromos: false,
    isPromotionRequired: false,
    showDuration: false,
    upsells: [],
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: false,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: 'c6bd2ed4-32d9-4bdd-8d1f-8b09222853b0',
    isLocalListing: true,
    steps: [
        {
            routeName: 'offerFlow-pintenfritz-steps-step-1-date',
            name: 'offerFlow.pages.stepDate.name.common',
        },
        {
            routeName: 'offerFlow-pintenfritz-steps-step-2-passengers',
            name: 'offerFlow.pages.stepPassengers.name.common',
            skipIfUpsell: true,
        },
    ],
} satisfies ProductConfigActivity;
